<div *ngIf="headLine || caption" class="pricing-prompt-container">
  <div class="prompt" *ngIf="headLine" [innerHTML]="headLine | trustHtml"></div>
  <div class="detail" *ngIf="caption">{{ caption }}</div>
</div>